import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Post Info'
export const group = 'Dynamic Post Template'
export const beta = false

export const defaultOptions = {
  content: {
    data: {
      type: 'blog-post-info-mod'
    }
  }
}

export const icon = `
`

export default class ElPostInfo extends SectionProvider {
  constructor (options = {}) {
    super('ElPostInfo', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
